import { ICreateZoneRequest, IUpdateZoneRequest, IDeleteZoneRequest, ICheckAndPlanRouteRequest } from "./types";
import { baseZonesApi, ZoneEntity } from '@src/core/features';

export const zonesFeatureApi = baseZonesApi.injectEndpoints({
  endpoints: (builder) => ({
    getZone: builder.query<ZoneEntity, number>({
      query: (zoneId) => ({
        url: `/api/no-fly-zones/${zoneId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),

    createZone: builder.mutation<ZoneEntity, ICreateZoneRequest>({
      invalidatesTags: ['GetZones'],
      query: (data) => ({
        url: '/api/no-fly-zones',
        method: 'POST',
        data,
      }),
    }),

    updateZone: builder.mutation<ZoneEntity, IUpdateZoneRequest>({
      invalidatesTags: ['GetZones'],
      query: (data) => ({
        url: `/api/no-fly-zones/${data.id}`,
        method: 'PUT',
        data,
      }),
    }),

    deleteZone: builder.mutation<void, IDeleteZoneRequest>({
      invalidatesTags: ['GetZones'],
      query: (data) => ({
        url: `/api/no-fly-zones/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetZoneQuery,
  useCreateZoneMutation,
  useUpdateZoneMutation,
  useDeleteZoneMutation,
} = zonesFeatureApi;
